import { render, staticRenderFns } from "./setOfficalMsg.vue?vue&type=template&id=e4a63eda&"
import script from "./setOfficalMsg.vue?vue&type=script&lang=js&"
export * from "./setOfficalMsg.vue?vue&type=script&lang=js&"
import style0 from "./setOfficalMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports